import React, { useState } from 'react'

import {Box, Grid} from '@mui/material'

import useStyles from '../../../../styles/global-mui.js'
import LivePopupCreator from './popup/LivePopupCreator.js';
import { useDispatch, useSelector } from 'react-redux';
import { createLive } from '../../../../actions/lives.js';

import { ReactComponent as MySvgIcon } from '../../../../images/picto/standard/creer_un_direct.svg';
import { ReactComponent as MySvgIconHover } from '../../../../images/picto/blue/creer_un_direct_bleu.svg';
import DsasButton from '../../../../v1/components/DsasButton/DsasButton.js';
import { Can } from '../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';

// gestion des directs - actualité 

const FormLive = () => {

    const dispatch = useDispatch()

    const [open, setOpen] = useState(false);

  const currentUser = useSelector(state => state.authentication.currentUser);
  const provider = currentUser?.groups; // ou currentUser?.groups si c’est ça le "provider"

  const buildInitialLiveData = () => ({
    name: '',
    actualites: [],
    dateTime: new Date(),
    provider: provider ?? null, // fallback explicite si jamais le user n'est pas encore prêt
    userNames: []
  });

  const [state, setState] = useState(buildInitialLiveData);


   const handleClickOpen = () => {
    if (!provider) {
        console.warn('Provider non défini, popup non ouvert.');
        return;
      }
      setState(buildInitialLiveData());
      setOpen(true);
    };
    
    const handleClose = () => {
      setOpen(false);
    };

    const handleConfirm = () => {
      // On veut sauvegarder le live dans son état

      // Le but est de créer l'actualité et le live
      dispatch(createLive({...state, type : 'actu'}))

      handleClose()
    }

    const handleCancel = () => {
      setOpen(false);
    }

    const handleClear = () => setState(buildInitialLiveData());

    const RenderIcon = (props) => <MySvgIcon key={props.key} />;
    const RenderIconHover = (props) => <MySvgIconHover key={props.key} />;



    return (
      <Box display={'grid'}>
        {/*PAGE TITLE*/}
        <Box className='centered-medium-wrapper'>
            <h1 className='page-title'>Gestion des directs</h1>
        </Box>
        <Box className='medium-separator'></Box>
        <Box>
         <Box className="small-padding"></Box>
            <Grid container alignItems="center" className='padding-wrapper'>
                <Grid justifyItems="center" item xs={12} sm={12} md={12}>
                  <Box className='centered-wrapper'>

                  <Can permission={PERMISSIONS.DIVERS_LIVES_HOME_BUTTON_CREATE}>
                  <DsasButton 
                    label={`Créer un direct d'actu`}
                    variant='secondary' 
                    customIcon={RenderIcon}
                    customIconHover={RenderIconHover}
                    customCss={{
                      display: 'flex',
                      alignItems: 'center'}}
                    onClick={handleClickOpen} ></DsasButton>
                  </Can>
          
                {/* Rendu hors du Box cliquable */}
                 <LivePopupCreator 
                  open={open} 
                  setOpen={setOpen}
                  handleConfirm={handleConfirm}
                  handleCancel={handleCancel}
                  handleClear={handleClear}
                  state={state} 
                  setState={setState}/>

                  </Box>
                  </Grid>
                </Grid>
        </Box>
    </Box>
    )
}

export default FormLive